module.exports = __webpack_public_path__ + "img/Mom-icons_Attribution.d7871bab.png";